exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".domain-authentication-icon-1{fill:#bfe7e3}.domain-authentication-icon-2{fill:#001927}.domain-authentication-icon-3{fill:#fff}.domain-authentication-icon-4{fill:#72cac2}.domain-authentication-icon-5{isolation:isolate}\n", ""]);
